var exports = {
  "_": "xdbfd91f1--b29a05--img",
};

module.exports = exports;
